module.exports = __webpack_public_path__ + "static/media/bigbeestudio.4d38e6d5.jpg";